import React, { useEffect, useState } from 'react'
import { config, urlPaths } from '../../../utils/config'
import { fetchAPI } from '../../../utils/fetch'
import { useNavigate } from 'react-router-dom';

const PostHead = ({ selectedList, setSelectedList, selectedSort, setSelectedSort, selectedDate, setSelectedDate, setcurrentCursor, selectedPeopleList, setSelectedPeopleList, setPeopleListInitialized, userProfile }) => {
  const userDetails = JSON.parse(localStorage.getItem("userData"));
  // const [userDetail, setUserDetail] = useState(userDetails);

  const [lists, setLists] = useState([{
    "id": "unipile_all_list_filter",
    "list_name": "Select Keyword List",
    "keywords": []
  }]);

  const [keywordloading, setkeywordLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setkeywordLoading(true);
      try {
        const response = await fetchAPI.get(
          `${config.urlPlatform}/api/v2/unipile/linkedin/keywords/getAll`,
          { withCredentials: true }
        );

        if (response?.data?.success) {
          setLists((prevLists) => [
            prevLists[0],
            ...response?.data?.data,
          ]);
        }
      } catch (error) {
        console.log("Error fetching filters", error);
      } finally {
        setkeywordLoading(false);
      }
    };

    fetchData();
  }, []);

  const [people, setPeople] = useState([{
    "id": "",
    "list_name": "Select People's List",
  }]);

  const [peopleloading, setpeopleLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setpeopleLoading(true);
      try {
        const response = await fetchAPI.get(
          `${config.urlPlatform}/api/v2/unipile/linkedin/people/getAll`,
          { withCredentials: true }
        );

        if (response?.data?.success) {
          const peopleData = response.data.data;

          setPeople((prevLists) => [prevLists[0], ...peopleData]);

          // ✅ Only set default if user is a new unipile user AND nothing is selected yet
          if (
            userProfile?.newUnipileUser === true &&
            !selectedPeopleList &&
            peopleData.length > 0
          ) {
            const defaultId = peopleData[0].id;
            setSelectedPeopleList(defaultId); // 👈 Send default to parent
            setPeopleListInitialized(true); // ✅ Inform parent it's set
          } else {
            setPeopleListInitialized(true); // ✅ Inform parent it's set
          }
        }
      } catch (error) {
        console.log("Error fetching people list", error);
      } finally {
        setpeopleLoading(false);
      }
    };

    fetchData();
  }, []);

  const sortOptions = [{ name: "Relevance", value: "relevance" }, { name: "Date", value: "date" }];
  const dateFilters = [{ name: "Date Posted", value: "" }, { name: "Past Day", value: "past_day" }, { name: "Past Week", value: "past_week" }, { name: "Past Month", value: "past_month" }];

  const navigate = useNavigate();
  return (
    <div style={{ fontFamily: '"Exo 2", serif' }}>
      <div style={{ textAlign: "left" }}>
        <div style={{ textAlign: "center"}}>
          <h2 style={{ marginBottom: "0.5rem" }}>Your Customized LinkedIn Feed</h2>
        </div>
        <div style={{ fontSize: "15px", color: "gray" }}>
          We’ve set up a customized LinkedIn feed for you. Start by writing your first comment,
          then create your own list to see even more relevant content!
        </div>
      </div>

      <div style={buttonContainerStyle}>
        <div onClick={() => navigate(urlPaths.listposts)} style={buttonStyle}>
          Add/Edit keyword lists
        </div>
        <div onClick={() => navigate(urlPaths.peopleLists)} style={buttonStyle}>
          Add/Edit people’s lists
        </div>
      </div>
      {/* Filters */}
      <div style={{ display: "flex", alignItems: "center", margin: "1rem 0 0 0", gap: "1rem" }}>
        {/* List Filter */}
        <select
          value={selectedList}
          onChange={(e) => { setSelectedPeopleList(""); setSelectedList(e.target.value); setcurrentCursor(null) }}
          style={keywordSelectStyle}
          disabled={keywordloading}
        >
          {keywordloading && <option>Loading...</option>}

          {!keywordloading &&
            lists.map((list, index) => (
              <option key={list.id} value={list.keywords}>
                {list.list_name}
              </option>
            ))}
        </select>

        {/* People list Filter only visible to influencers plan*/}
        {
          (userDetails?.sevenDayTrial ||
            ((userDetails?.plan === "proMonth" || userDetails?.plan === "proMonth_yearly") && userDetails?.paidStatus === true)) &&
          <select
            value={selectedPeopleList}
            onChange={(e) => { setSelectedList(""); setSelectedPeopleList(e.target.value); setcurrentCursor(null) }}
            style={peopleSelectStyle}
            disabled={peopleloading}
          >
            {peopleloading && <option>Loading...</option>}

            {!peopleloading &&
              people.map((list, index) => (
                <option key={list.id} value={list.id}>
                  {list.list_name}
                </option>
              ))}
          </select>
        }

        {/* Sort Filter */}
        <select
          value={selectedSort}
          onChange={(e) => { setSelectedSort(e.target.value); setcurrentCursor(null) }}
          style={dropdownStyle}
        >
          {sortOptions.map((option, index) => (
            <option key={index} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>

        {/* Date Filter */}
        <select
          value={dateSelectStyle}
          onChange={(e) => { setSelectedDate(e.target.value); setcurrentCursor(null) }}
          style={dropdownStyle}
        >
          {dateFilters.map((date, index) => (
            <option key={index} value={date.value}>
              {date.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

// Dropdown styling
const keywordSelectStyle = {
  width: "50%", // Increased width
  padding: "8px",
  borderRadius: "5px",
  border: "1px solid gray",
  backgroundColor: "white",
  fontSize: "12px", // Slightly larger font
  cursor: "pointer"
};

const peopleSelectStyle = {
  width: "50%", // Increased width
  padding: "8px",
  borderRadius: "5px",
  border: "1px solid gray",
  backgroundColor: "white",
  fontSize: "12px", // Slightly larger font
  cursor: "pointer"
};

const dateSelectStyle = {
  width: "20%", // Reduced width
  padding: "8px",
  borderRadius: "5px",
  border: "1px solid gray",
  backgroundColor: "white",
  fontSize: "12px", // Slightly smaller font
  cursor: "pointer"
};

const dropdownStyle = {
  width: "33%",
  padding: "8px",
  borderRadius: "5px",
  border: "1px solid gray",
  backgroundColor: "white",
  fontSize: "12px",
  cursor: "pointer"
};

// const buttonStyle = {
//   cursor: "pointer",
//   border: "1px solid gray",
//   padding: "8px 12px",
//   borderRadius: "5px",
//   fontSize: "12px",
//   whiteSpace: "nowrap",
//   display: "inline-block",
//   marginRight: "2px", // Optional: spacing between buttons
// };

const buttonContainerStyle = {
  display: "flex",
  justifyContent: "center",
  gap: "1rem",
  marginTop: "1rem"
};

const buttonStyle = {
  cursor: "pointer",
  padding: "8px 16px",
  border: "1px solid gray",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "12px",
  fontWeight: "500",
  textAlign: "center"
};

export default PostHead
